import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { PurchasesListPage } from './PurchasesListPage';
import { SalesListPage } from './SalesListPage';
import { PaymentsListPage } from '../../debts/routes/PaymentsListPage';

// `Opérations` tab — three-segment view: Achats / Ventes / Règlements.
// /purchases and /sales stay routable for deep links and post-submit
// redirects. ?view= drives which segment is active.

type Segment = 'purchases' | 'sales' | 'settlements';

export function OperationsPage() {
  const { t } = useTranslation();
  const [params, setParams] = useSearchParams();

  const raw = params.get('view');
  const segment: Segment =
    raw === 'sales' ? 'sales' : raw === 'settlements' ? 'settlements' : 'purchases';

  function select(next: Segment) {
    setParams(next === 'purchases' ? {} : { view: next }, { replace: true });
  }

  return (
    <>
      <div className="segmented" role="group" aria-label={t('nav.operations')}>
        <button
          type="button"
          className={`segmented__item${segment === 'purchases' ? ' is-active' : ''}`}
          aria-pressed={segment === 'purchases'}
          onClick={() => select('purchases')}
        >
          {t('purchases.title')}
        </button>
        <button
          type="button"
          className={`segmented__item${segment === 'sales' ? ' is-active' : ''}`}
          aria-pressed={segment === 'sales'}
          onClick={() => select('sales')}
        >
          {t('sales.title')}
        </button>
        <button
          type="button"
          className={`segmented__item${segment === 'settlements' ? ' is-active' : ''}`}
          aria-pressed={segment === 'settlements'}
          onClick={() => select('settlements')}
        >
          {t('nav.payments')}
        </button>
      </div>
      {segment === 'purchases' ? <PurchasesListPage /> : null}
      {segment === 'sales' ? <SalesListPage /> : null}
      {segment === 'settlements' ? <PaymentsListPage /> : null}
    </>
  );
}
